export const isOnboardingIconEnabled = (subscriptions, isDemo) => {
  const hasPaidSubscription = subscriptions.some(s => s.isTrial === false)

  if (isDemo) {
    return false
  }

  return hasPaidSubscription
}

export const isOnboardingNavigationEnabled = (subscriptions, isDemo) => {
  const hasPaidSubscription = subscriptions.some(s => s.isTrial === false) || isDemo

  if (isDemo) {
    return true
  }

  return !hasPaidSubscription
}
